import OptionButton from '@/components/v1/OptionButton'
import StepHeading from '@/components/v1/StepHeading'
import StickyFooter from '@/components/v1/StickyFooter'
import { type AnswerType } from '@app-studio-web/ui/types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

interface Props {
  answers: AnswerType[]
  subtitleKey: string
  titleKey: string
}

export default function MultiSelectStep({
  answers,
  subtitleKey,
  titleKey,
}: Props) {
  const [selectedValues, setSelectedValues] = useState<string[]>([])
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target

    setSelectedValues((current) =>
      checked
        ? [...current, value]
        : current.filter((selectedValue) => selectedValue !== value),
    )
  }

  return (
    <div className="flex grow flex-col gap-5 pt-1">
      <StepHeading subtitleKey={subtitleKey} titleKey={titleKey} />

      <Form className="flex grow flex-col" method="post">
        <div className="flex flex-col gap-2.5">
          {answers.map((answer, index) => {
            const englishTitle = t(answer.title, { lng: 'en' })
            const value = answer.value || englishTitle

            return (
              <OptionButton
                animationDelayMs={120 + index * 40}
                emoji={answer.emoji}
                id={englishTitle}
                indicator="checkbox"
                isSelected={selectedValues.includes(value)}
                key={englishTitle}
                name={t(titleKey, { lng: 'en' })}
                onChange={handleChange}
                subtitle={answer.subtitle ? t(answer.subtitle) : undefined}
                title={t(answer.title)}
                value={value}
              />
            )
          })}
        </div>

        <StickyFooter>
          <button
            className="hw-button-primary"
            disabled={selectedValues.length === 0}
            type="submit"
          >
            {t('shared.continue')}
          </button>
        </StickyFooter>
      </Form>
    </div>
  )
}
